import {
  fetchWrapper,
  handleResponse,
  hcUrlV3,
  buildOpts,
  formatBody,
} from 'services/RequestService/helpers';

export const claimUserBehavioralDiscount = async ({
  params: { userBehavioralDiscountId, menuSlug },
}) => {
  const response = await fetchWrapper(
    hcUrlV3(`/weekly_baskets/${menuSlug}/user_behavioral_discount_claims`),
    buildOpts({
      method: 'PATCH',
      body: formatBody({ userBehavioralDiscountId }),
    })
  );

  return handleResponse(response);
};
